require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-team-asia-consultant.json") })
        }
      }, "path---en-us-team-asia-consultant");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-team-asia-consultant!./.cache/json/en-us-team-asia-consultant.json
// module id = 587
// module chunks = 231608221292675